var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeam = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19623"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19615"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19465",
  transform: "translate(.126 .067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "none",
  "data-name": "Ellipse 1392",
  transform: "translate(-.126 -.068)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19466"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 24.998a3.361 3.361 0 1 1 3.361-3.361A3.36 3.36 0 0 1 25 24.998",
  "data-name": "Path 16694"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.776 31.721c0-2.6-2.589-4.706-5.774-4.706s-5.775 2.1-5.775 4.706",
  "data-name": "Path 16695"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.139 24.996a2.654 2.654 0 0 1 0-5.307",
  "data-name": "Path 16696"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.389 27.34c-2.515 0-4.559 1.661-4.559 3.714",
  "data-name": "Path 16697"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.861 19.691a2.654 2.654 0 0 1 0 5.307",
  "data-name": "Path 16698"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.17 31.054c0-2.053-2.044-3.714-4.559-3.714",
  "data-name": "Path 16699"
}))))));
export { SvgTeam as ReactComponent };
export default __webpack_public_path__ + "static/media/team.8822ad7a6af08cd712412c3e9df68df5.svg";